import { plural } from "./plural";

/** Russian UI copy: the source catalogue. Kazakh (kk.ts) must have the same shape. */
export const ru = {
  common: {
    loading: "Загрузка",
    retry: "Повторить",
    back: "Назад",
    close: "Закрыть",
    cancel: "Отмена",
    confirm: "Подтвердить",
    next: "Далее",
    notLoaded: "Не удалось загрузить",
    notSaved: "Не сохранено",
    demo: "демо",
  },
  lang: { label: "Язык", ru: "Рус", kk: "Қаз" },
  nav: {
    clientLabel: "Разделы студии",
    home: "Главная",
    services: "Услуги",
    bookings: "Записи",
    assistant: "Помощник",
    studio: "Студия",
    ownerLabel: "Кабинет",
    day: "День",
    newBooking: "Запись",
    stats: "Статистика",
    more: "Ещё",
  },
  studio: {
    demoTitle: "Демо-студия",
    demoText: "Записи здесь демонстрационные, уведомления не отправляются.",
    previewTitle: "Предпросмотр",
    previewText: "Студия ещё не запущена: записи помечаются как тестовые и будут удалены при запуске.",
    notConfigured: "Приложение не настроено",
    missingEnv: (v: string) => `Не заданы переменные окружения: ${v}`,
    loading: "Загружаем студию",
    unavailable: "Студия недоступна",
  },
  notFound: {
    pageTitle: "Страница не найдена",
    pageText: "Такого раздела нет.",
    toHome: "На главную студии",
    linkTitle: "Откройте ссылку студии",
    linkText: "Адрес онлайн-записи выглядит так: /s/название-студии/",
  },
  price: {
    onRequest: "Цена по запросу",
    from: (v: string) => `от ${v}`,
    byStudio: "Уточнит студия",
  },
  duration: {
    days: (d: string, n: number) => `${d} ${plural(n, "сутки", "суток", "суток")}`,
    minutes: (m: number) => `${m} мин`,
    hours: (h: number) => `${h} ч`,
    hoursMinutes: (h: number, m: number) => `${h} ч ${m} мин`,
  },
  home: {
    book: "Записаться",
    upcoming: "Ваша ближайшая запись",
    services: "Услуги",
    allServices: "Все услуги",
    noServicesTitle: "Услуги скоро появятся",
    noServicesText: "Студия ещё настраивает каталог. Позвоните, чтобы записаться.",
    works: "Работы",
    directions: "Направления",
    findUs: "Как нас найти",
    todayHours: (h: string) => `Сегодня открыто: ${h}`,
    closedToday: "Сегодня выходной",
    whatsapp: "Написать в WhatsApp",
    instagram: "Наш Instagram",
    route: "Маршрут",
  },
  services: {
    title: "Услуги",
    category: "Категория",
    all: "Все",
    emptyCategory: "Нет услуг в этой категории",
  },
  booking: {
    steps: { service: "Выберите услугу", time: "Дата и время", contacts: "Ваши контакты", review: "Проверьте запись" },
    stepOf: (i: number, total: number) => `Шаг ${i} из ${total}`,
    closeLabel: "Закрыть запись",
    service: "Услуга",
    when: "Когда",
    duration: "Длительность",
    price: "Стоимость",
    contacts: "Контакты",
    slotTakenTitle: "Время уже занято",
    notCreated: "Запись не создана",
    otherTime: "Другое время",
    sending: "Записываем…",
    resend: "Повторить отправку",
    submit: "Записаться",
    editContacts: "Изменить контакты",
  },
  time: {
    dateChoice: "Выбор даты",
    noFreeSuffix: ", нет свободного времени",
    loadingSlots: "Загружаем свободное время",
    noFreeTitle: "Нет свободного времени",
    pickOtherDay: "Выберите другой день.",
    freeTime: "Свободное время",
    multiDay: (days: number) => `Это время приёма. Работа длится ${days} сут., выдача — после завершения.`,
    tzNote: (tz: string) => `Время указано по часовому поясу студии (${tz}).`,
  },
  contacts: {
    name: "Имя",
    phone: "Телефон",
    phoneHint: "Студия позвонит, если что-то изменится",
    email: "E-mail",
    comment: "Комментарий",
    errName: "Укажите имя",
    errPhone: "Номер из 7–15 цифр, можно с +",
    errEmail: "Проверьте e-mail",
    errComment: "Не больше 500 символов",
  },
  my: {
    title: "Мои записи",
    emptyTitle: "Здесь появятся ваши записи",
    emptyText: "Записи хранятся на этом устройстве. Если вы записывались с другого телефона, откройте ссылку из подтверждения.",
    upcoming: "Предстоящие",
    past: "Прошедшие",
    forget: "Забыть записи на этом устройстве",
  },
  bookingPage: {
    title: "Запись",
    booked: "Вы записаны",
    incompleteTitle: "Ссылка неполная",
    incompleteText: "Откройте ссылку на запись целиком — она содержит ключ доступа.",
    confirmedTitle: "Запись подтверждена",
    confirmedText: "Сохраните эту страницу: по ссылке можно перенести или отменить запись без регистрации.",
    status: { confirmed: "Подтверждена", completed: "Завершена", cancelled: "Отменена", no_show: "Неявка" } as Record<string, string>,
    address: "Адрес",
    copy: "Скопировать ссылку на запись",
    copied: "Ссылка скопирована",
    reschedule: "Перенести",
    cancel: "Отменить запись",
    cantChange: (hours: number, phone: string) => `Изменить запись онлайн уже нельзя (меньше ${hours} ч до начала). Позвоните: ${phone}`,
    cancelFailed: "Не удалось отменить",
    cancelQuestion: "Отменить запись?",
    cancelText: (what: string) => `${what}. Время освободится для других.`,
    keep: "Оставить",
  },
  notify: {
    ics: "Скачать файл для календаря (.ics)",
    icsSaved: "Файл скачан. Откройте его, чтобы календарь добавил событие с напоминанием за 2 часа. После переноса скачайте файл заново.",
    icsHint: "Мы не меняем ваш календарь сами — вы добавляете событие из файла.",
    icsDescription: (url: string) => `Запись: ${url}`,
    pushOn: "Напоминания на это устройство включены.",
    disable: "Отключить",
    enable: "Включить напоминания на этом устройстве",
    demo: "Это демо-запись: студия не отправляет по ней уведомления.",
    failedTitle: "Напоминания не включены",
    permissionDenied: "Разрешение не выдано.",
  },
  reschedule: {
    title: "Перенос записи",
    now: (v: string) => `Сейчас: ${v}`,
    serviceGoneTitle: "Услуга больше не доступна онлайн",
    serviceGoneText: "Позвоните в студию, чтобы перенести запись.",
    newTime: (v: string) => `Новое время: ${v}`,
    failed: "Не перенесли",
    keptSuffix: "Текущая запись сохранена.",
    confirm: "Перенести на это время",
    pickOther: "Выбрать другое",
  },
  about: {
    call: (phone: string) => `Позвонить: ${phone}`,
    map: "Открыть на карте",
    website: "Сайт",
    hours: "Часы работы",
    contacts: "Контакты",
    write: "Написать",
    directions: "Как добраться",
    route: "Построить маршрут",
    mapTitle: (address: string) => `Карта: ${address}`,
    dayOff: "выходной",
    address: "Адрес",
    tz: (tz: string) => `Часовой пояс студии: ${tz}`,
    rules: "Правила",
  },
  install: {
    title: "Значок на главном экране",
    install: (name: string) => `Добавить «${name}» на главный экран`,
    ios: "Нажмите «Поделиться», затем «На экран „Домой“» — сайт откроется одним нажатием, как обычный значок. Напоминания на iPhone приходят, только если сайт добавлен на экран «Домой».",
    other: "Откройте меню браузера (⋮) и выберите «Добавить на главный экран».",
  },
  pwa: {
    notConfigured: "Уведомления не настроены для этой студии.",
    iosHome: "На iPhone уведомления приходят, только если сайт добавлен на экран «Домой»: «Поделиться» → «На экран „Домой“» (iOS 16.4+).",
    unsupported: "Этот браузер не поддерживает push-уведомления.",
    denied: "Уведомления запрещены в настройках браузера для этого сайта.",
  },
  assistant: {
    title: "Помощник",
    noConnection: "Нет связи с помощником.",
    unavailable: "Помощник сейчас недоступен.",
    disabled: "Помощник выключен в этой студии.",
    tooMany: "Слишком много вопросов подряд. Попробуйте через несколько минут.",
    noAccess: "Нет доступа: войдите в кабинет заново.",
    failed: (status: number) => `Ошибка помощника (${status}).`,
    placeholderOwner: "Например: сколько получили денег за неделю?",
    placeholderClient: "Например: когда свободно в субботу?",
    emptyOwner: "Спросите о записях, свободном времени или статистике. Ответы основаны на данных студии.",
    emptyClient: "Спросите об услугах, ценах, свободном времени или своей записи.",
    thinking: "Помощник смотрит данные студии…",
    unavailableTitle: "Помощник недоступен",
    bookingWorks: "Запись работает как обычно.",
  },
  errors: {
    slot_unavailable: "Это время только что заняли. Выберите другое.",
    slot_not_offered: "Это время недоступно для записи.",
    studio_not_found: "Студия не найдена или ещё не опубликована.",
    service_not_found: "Услуга больше недоступна.",
    booking_not_found: "Запись не найдена. Проверьте ссылку.",
    booking_not_active: "Запись уже отменена или завершена.",
    change_window_closed: "Изменить запись онлайн уже нельзя — позвоните в студию.",
    invalid_phone: "Проверьте номер телефона.",
    invalid_name: "Укажите имя.",
    comment_too_long: "Комментарий слишком длинный.",
    rate_limited: "Слишком много попыток. Подождите немного и повторите.",
    idempotency_key_reused: "Данные изменились во время отправки. Попробуйте ещё раз.",
    forbidden: "Нет доступа к этой студии.",
    not_authenticated: "Войдите в кабинет.",
    block_conflicts: "На это время уже есть записи.",
    invalid_range: "Проверьте начало и конец периода.",
    resource_not_suitable: "Этот ресурс не выполняет услугу.",
    payment_in_future: "Платёж нельзя записать будущей датой.",
    booking_in_future: "Визит ещё не начался.",
    invalid_amount: "Проверьте сумму.",
    invalid_period: "Неверный период.",
    media_managed_by_config: "Это фото из конфигурации студии — его меняют через публикацию.",
    invalid_media_path: "Не удалось сохранить фото.",
    network: "Нет связи с сервером. Проверьте интернет.",
    unknown: "Что-то пошло не так. Повторите попытку.",
  } as Record<string, string>,
  login: {
    title: "Вход в кабинет",
    method: "Способ входа",
    byPhone: "Телефон",
    byEmail: "Почта",
    phone: "Номер телефона",
    phoneHint: "Номер, который привязан к кабинету. Пришлём код в SMS.",
    email: "E-mail",
    emailHint: "Почта, на которую выдан доступ. Пришлём код в письме.",
    sendCode: "Получить код",
    code: "Код из 6 цифр",
    codeSentPhone: (dest: string) => `Отправили SMS с кодом на ${dest}.`,
    codeSentEmail: (dest: string) => `Отправили письмо на ${dest}. Нажмите в нём ссылку для входа — или введите код ниже, если он есть в письме. Нет письма — проверьте спам.`,
    verify: "Войти",
    resend: "Отправить код ещё раз",
    resendIn: (s: number) => `Повторно — через ${s} с`,
    change: "Изменить номер или почту",
    failed: "Не удалось войти",
    notInvited: "Этот номер или e-mail не приглашён в кабинет.",
    badCode: "Код неверный или устарел. Запросите новый.",
    badPhone: "Проверьте номер: от 10 цифр, можно с +.",
    smsUnavailable: "Отправка SMS не настроена. Войдите по почте.",
    tooOften: "Код уже отправлен. Подождите минуту и повторите.",
    footer: "Пароль не нужен. Доступ выдаёт администратор платформы, регистрации нет.",
  },
  owner: {
    checking: "Проверяем вход",
    loading: "Загружаем кабинет",
    noAccessTitle: "Нет доступа",
    noAccessText: (account: string) => `Аккаунт ${account} не является владельцем этой студии.`,
    logout: "Выйти",
  },
  day: {
    today: "Сегодня",
    block: "Блок",
    prev: "Предыдущий день",
    next: "Следующий день",
    toToday: "К сегодняшнему дню",
    summary: (n: number, money: string) => `${n} актив. записей · ожидаемая стоимость ${money} (это не выручка)`,
    emptyTitle: "Записей нет",
    emptyText: "Свободный день.",
    add: "Добавить запись",
    blockLabel: "Блокировка",
    status: { cancelled: "Отменена", completed: "Выполнена", no_show: "Неявка" },
  },
  ownerBooking: {
    title: "Запись",
    notFound: "Запись не найдена в этом дне",
    toSchedule: "К расписанию",
    client: "Клиент",
    phone: "Телефон",
    service: "Услуга",
    start: "Начало",
    end: "Окончание",
    resource: "Ресурс",
    price: "Цена в записи",
    paid: "Получено",
    comment: "Комментарий",
    call: "Позвонить",
    write: "Написать",
    move: "Перенести",
    done: "Выполнена",
    noShow: "Неявка",
    cancel: "Отменить",
    markAfterStart: "Отметить визит можно после его начала.",
    payment: "Оплата",
    paymentHint: "Записывайте фактически полученные деньги. Возврат — отрицательной суммой.",
    amount: "Сумма",
    method: "Способ",
    card: "Карта",
    cash: "Наличные",
    transfer: "Перевод",
    payFailed: "Платёж не записан",
    recordPayment: "Записать платёж",
    cancelQuestion: "Отменить запись?",
    doneQuestion: "Отметить выполненной?",
    noShowQuestion: "Отметить неявку?",
    cancelText: "Время освободится, клиенту уйдёт уведомление (если он их включил).",
    statusText: "Статус попадёт в статистику за сегодня.",
    cancelAction: "Отменить запись",
  },
  newBooking: {
    title: "Новая запись",
    service: "Услуга",
    pickService: "Выберите услугу",
    clientName: "Имя клиента",
    phone: "Телефон",
    comment: "Комментарий",
    submit: "Записать",
    needNamePhone: "Укажите имя и телефон",
  },
  slotPicker: {
    day: "День",
    picked: (v: string) => `Выбрано: ${v}`,
    failed: "Не выполнено",
  },
  block: {
    titleExisting: "Блокировка",
    titleNew: "Заблокировать время",
    removeFailed: "Не удалось снять",
    remove: "Снять блокировку",
    what: "Что блокируем",
    pick: "Выберите",
    from: "С",
    to: "По",
    time: "Время",
    reason: "Причина",
    reasonPlaceholder: "Обслуживание, отпуск…",
    conflictTitle: "Пересекается с записями",
    submit: "Заблокировать",
    tzNote: (tz: string) => `Время в часовом поясе студии (${tz}).`,
  },
  stats: {
    title: "Статистика",
    period: "Период",
    periods: { today: "Сегодня", yesterday: "Вчера", week: "Неделя", month: "Месяц", last_7_days: "7 дней", last_30_days: "30 дней" } as Record<string, string>,
    demoTitle: "В данных есть демо-записи",
    demoText: "Они удалятся при запуске студии.",
    received: "Получено денег",
    receivedHint: (n: number) => `${n} платеж(ей) — это выручка`,
    completed: "Выполнено заказов",
    completedHint: (v: string) => `на сумму ${v} по ценам записей`,
    visits: "Визиты",
    visitsHint: "клиент пришёл (начавшиеся записи)",
    upcoming: "Впереди",
    upcomingHint: (v: string) => `ожидается ${v} — не выручка`,
    cancelled: "Отмены",
    noShow: "Неявки",
    forPeriod: "за период",
    top: "Популярные услуги",
  },
  settings: {
    title: "Ещё",
    blocks: "Блокировки и простой",
    blocksText: "Закрыть мастера или рабочее место на время",
    photos: "Фотографии",
    photosText: "Свои фото работ и обложка",
    assistant: "Помощник",
    assistantText: "Вопросы о записях и статистике",
    openClient: "Открыть страницу клиента",
    pushTitle: "Уведомления о новых записях",
    disableHere: "Отключить на этом устройстве",
    enableHere: "Включить на этом устройстве",
    notLive: "Пока студия не запущена, уведомления не отправляются.",
    notEnabled: "Не включено",
    launch: "Запуск студии",
    live: "Студия работает: записи настоящие, уведомления отправляются.",
    mustFix: "Перед запуском нужно исправить",
    ready: (n: number) => `Всё готово. При запуске удалятся ${n} тестовых записей; фото и настройки останутся.`,
    notLaunched: "Не запущено",
    launchAction: "Запустить студию",
    logout: "Выйти из кабинета",
    problems: {
      no_active_services: "Нет активных услуг с исполнителями",
      no_working_hours: "Не заданы часы работы",
      no_contact_phone: "Не указан телефон",
      no_address: "Не указан адрес",
      demo_config: "Это демо-студия — её нельзя запустить",
      config_needs_review: "В business.json есть непроверенные пункты (review_notes)",
      no_owner: "Нет владельца",
    } as Record<string, string>,
  },
  photos: {
    title: "Фотографии",
    photo: "Фото",
    photoHint: "JPG, PNG или WebP до 8 МБ",
    service: "Услуга",
    pickService: "Для какой услуги",
    pickServicePlaceholder: "Выберите услугу",
    forService: (name: string) => `Услуга: ${name}`,
    rules: "Ваши фото заменяют примеры на сайте: обложку и фото услуги — сразу, а в «Работах» показываются только ваши фото, как только загружено хотя бы одно. Удалите своё фото — вернётся пример.",
    mine: "Ваши фото",
    where: "Куда",
    gallery: "Галерея",
    cover: "Обложка",
    alt: "Описание для незрячих",
    notUploaded: "Не загружено",
    upload: "Загрузить",
    emptyTitle: "Своих фото пока нет",
    emptyText: "Пока на сайте примеры. Загрузите свои фото — они сразу их заменят.",
    delete: "Удалить",
    notDeleted: "Не удалено",
  },
};

export type Messages = typeof ru;
